import React from 'react';
import PropTypes from 'prop-types';
import './SelectorInput.scss';

const propTypes = {
    labelTitle: PropTypes.string,
    defaultValue: PropTypes.string,
    selectorClasses: PropTypes.string,
    holderClasses: PropTypes.string,
    options: PropTypes.array.isRequired
};

const defaultProps = {
    selectorClasses: 'select--field',
    holderClasses: 'select-input-holder',
};

export default class SelectorInput extends React.Component {
    constructor(props) {
        super(props);
        this.state ={
            value: ''
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({value: event.target.value});
    }

    render() {

        const {labelTitle, options, defaultValue, selectorClasses, holderClasses} = this.props;
       // console.log('current Val', this.state.value);

        return (
            <div className={holderClasses}>
                <select className={selectorClasses} value={this.state.value} onChange={this.handleChange}>
                    {this.props.options.map((option, index) => (
                        <option key={index} value={option} className='s-option-classes'>{option}</option>
                    ))}
                </select>

            </div>
        );
    }

};

SelectorInput.propTypes = propTypes;
SelectorInput.defaultProps = defaultProps;



// WEBPACK FOOTER //
// ./src/components/SelectorInput/index.js